/* eslint-disable react/forbid-component-props */
import { styled } from '@mui/material/styles';
import ReactCountryFlag from 'react-country-flag';

interface CountryFlagProps {
  className?: string;
  countryCode: string;
}

const flagSize = {
  width: '24px',
  height: '18.5px',
};

/** Flat SVG flag treatment used by the Applications Countries Contacted column. */
export const CountryFlag = ({ className, countryCode }: CountryFlagProps) => (
  <StyledCountryFlag className={className} countryCode={countryCode.toUpperCase()} svg aria-hidden="true" style={flagSize} />
);

const StyledCountryFlag = styled(ReactCountryFlag)`
  flex: 0 0 auto;
  border: 1px solid #ccc;
`;
